import { useEffect, useState } from 'react'

import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { BsFloppyFill } from 'react-icons/bs'

import { CustomButton } from '../../../../../components/CustomButton'

import TiposService from '../../../../../services/database/TiposService'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'
import { CustomSpinner } from '../../../../CustomSpinner'

export function DadosIPI({
  isVisible,
  product,
  onNext,
  handleChange,
  setProduct,
}) {
  const [tipos, setTipos] = useState([])
  const [isLoadingTypes, setIsLoadingTypes] = useState(true)

  async function loadTypes() {
    try {
      setIsLoadingTypes(true)
      const tipos = await TiposService.getAll()

      setTipos(tipos)
    } catch (err) {
      console.log(`Erro ao carregar tipos: ${err}`)
      toast.error('Erro ao carregar os tipos!')
    } finally {
      setIsLoadingTypes(false)
    }
  }

  useEffect(() => {
    if (isVisible) {
      loadTypes()
    }
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Dados IPI</h4>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  CST IPI
                </Form.Label>

                {isLoadingTypes && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="CSTIPI"
                value={product.CSTIPI}
                onChange={(e) => handleChange(e, 'ipi')}
                disabled={isLoadingTypes}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingTypes ? 'Carregando...' : 'Selecione uma Opção'}
                </option>
                {tipos
                  .filter((tipo) => tipo.TIPO === 'CST IPI')
                  .map((tipo) => (
                    <option
                      key={tipo.ID}
                      value={tipo.CODIGO}
                    >
                      {tipo.DESCRICAO}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Label> % IPI </Form.Label>
              <Form.Control
                name="IPI"
                value={product.IPI}
                onChange={(e) => handleChange(e, 'ipi')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Código Selo IPI</Form.Label>
              <Form.Control
                name="CODIGOSELOIPI"
                value={product.CODIGOSELOIPI}
                onChange={(e) => handleChange(e, 'ipi')}
              />
            </Col>

            <Col>
              <Form.Label> Qtde Selo IPI </Form.Label>
              <Form.Control
                name="QTDESELOIPI"
                value={product.QTDESELOIPI}
                onChange={(e) => handleChange(e, 'ipi')}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label> Código Enquadramento IPI </Form.Label>
              <Form.Control
                name="CODIGOENQIPI"
                value={product.CODIGOENQIPI}
                onChange={(e) => handleChange(e, 'ipi')}
              />
            </Col>

            <Col
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-start',
              }}
            >
              <CustomButton
                title="Padrão"
                onClick={() => {
                  setProduct((prevState) => ({
                    ...prevState,
                    ipi: {
                      CODIGOSELOIPI: '00',
                      QTDESELOIPI: '0',
                      CODIGOENQIPI: '999',
                    },
                  }))
                }}
                styles={{
                  marginLeft: 0,
                }}
              >
                <BsFloppyFill />
              </CustomButton>
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
